import {FeatureGateTier, ProjectFeatureFlag} from 'common/report/constants';
import {ContentType, Dashboard} from 'common/report/dashboards/types';
import {CurrentProject} from 'common/report/model-resources/projects';
import {isAllowedSuperadminOverride} from 'common/report/util/saved-entities';

export const dashboardUtils = {
  canEditDashboard,
};

//TODO rename contentData to contentParams
export interface ContentDetails {
  contentId?: string;
  contentParams?: any;
  contentType: ContentType;
}

function canEditDashboard(dashboard: Pick<Dashboard, `allow_staff_override` | `is_superadmin` | `can_update_basic`>) {
  return dashboard.can_update_basic || isAllowedSuperadminOverride(dashboard);
}

export function getCardIdFromContent(contentId: string | number, contentType: ContentType) {
  return `${contentType}-${contentId}`;
}

export function isNestedDashboardsEnabled(project: CurrentProject) {
  const isInFeatureFlag = project?.hasFeatureFlag(ProjectFeatureFlag.NestedDashboards) || false;

  const isOnEnterprisePlan = project?.featureGateTier === FeatureGateTier.Enterprise;

  return isInFeatureFlag || isOnEnterprisePlan;
}

export function isSparkEnabled(project?: CurrentProject) {
  return project?.sparkAIEnabled;
}
